import { render } from "./Skeleton.vue?vue&type=template&id=8c482a8e"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=8c482a8e&lang=css"
script.render = render

export default script